import { graphql, useStaticQuery } from "gatsby";
import React, { Fragment, useEffect } from "react";
import { GoogleAnalytics } from "../components/GoogleAnalytics";
import ImageView from "../components/ImageView";
import { animation } from "../utils";
import Footer from "./Footer";
import Header from "./Header";
import ScrollTop from "./ScrollTop";

const Layout = ({ children, header, footer }) => {
  useEffect(() => {
    animation();
  }, []);

  const { sanitySitesettings } = useStaticQuery(
    graphql`
      query {
        sanitySitesettings {
          topBanner {
            enable
            welcome
            link1
            time
            link2
            social {
              icon
              url
            }
          }
          header {
            logo {
              alt
              asset {
                gatsbyImageData(
                  formats: WEBP
                  fit: FILLMAX
                  placeholder: BLURRED
                )
              }
            }
            logo2 {
              alt
              asset {
                gatsbyImageData(
                  width: 280
                  placeholder: BLURRED
                  formats: WEBP
                  layout: CONSTRAINED
                )
              }
            }
            button {
              title
              linkType
              link
              btnType
            }
            menu {
              parent {
                label
                link
                type
              }
              childMenu {
                type
                link
                label
              }
            }
          }
          footer {
            logo {
              alt
              asset {
                gatsbyImageData(fit: FILLMAX, placeholder: DOMINANT_COLOR)
              }
            }
            about
            email
            location
            _rawCc
            # news {
            #   title
            #   slug {
            #     current
            #   }
            #   thumbnail {
            #     alt
            #     asset {
            #       url
            #     }
            #   }
            #   publishedAt
            # }
            menu {
              label
              link
              type
            }
            info {
              label
              link
              type
            }
            newsletter {
              enable
              heading
              button {
                btnType
                link
                linkType
                title
              }
            }
            social {
              icon
              url
            }
          }
        }
      }
    `
  );

  return (
    <Fragment>
      <GoogleAnalytics />
      <ImageView />
      {/* <div
        className="global-top-banner"
        style={{
          backgroundColor: "#eece38",
          color: "#000",
          padding: "8px 16px",
          textAlign: "center",
          fontSize: "15px",
          fontWeight: 700,
          letterSpacing: "0.02em",
          zIndex: 1000,
        }}
      >
        <a
          href="https://invest.highlander.ai/renewables"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "inherit",
            textDecoration: "none",
          }}
        >
          Highlander Crowd Funding Campaign Launched
        </a>
      </div> */}
      <Header
        header={header}
        data={sanitySitesettings.header}
        topBanner={sanitySitesettings.topBanner}
      />
      <main id="main-content">{children}</main>
      <Footer footer={footer} data={sanitySitesettings?.footer} />
      <ScrollTop />
    </Fragment>
  );
};
export default Layout;
